/* 年月日 */
import React from 'react';
import RowTemplate from '../atoms/RowTemplate';
import DatePicker from '../organisms/DatePicker';
import Messages from '../molecules/Messages';
import Paragraph from '../atoms/Paragraph';
var is_se = document.getElementById('is-se');
var RowDate = function (_a) {
    var id = _a.id, label = _a.label, need = _a.need, value = _a.value, message = _a.message, name = _a.name, placeholder = _a.placeholder, help_msg = _a.help_msg, disabled = _a.disabled, readOnly = _a.readOnly, handleChange = _a.handleChange, handleBlur = _a.handleBlur, handleCalendarClose = _a.handleCalendarClose;
    var returnStringDateJp = function () {
        if (value !== null && typeof value !== 'undefined') {
            var year = value.getFullYear();
            var month = value.getMonth() + 1;
            var date = value.getDate();
            return year + "-" + month + "-" + date;
        }
        return '';
    };
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: disabled ? (React.createElement(Paragraph, { label: returnStringDateJp() })) : (React.createElement(React.Fragment, null,
            React.createElement(DatePicker, { id: id, className: "form-control", placeholder: placeholder, name: name, handleChangeDate: handleChange, selected: value, disabled: disabled, readOnly: readOnly, handleBlur: handleBlur, handleCalendarClose: handleCalendarClose, popperPlacement: is_se.dataset.value ? 'top-start' : undefined }),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message }))) }));
};
export default RowDate;
